// extracted by mini-css-extract-plugin
module.exports = {"google-ads":"google-ads-3bd7958a","googleAds":"google-ads-3bd7958a","google_image_div":"google_image_div-49e68b1a","googleImageDiv":"google_image_div-49e68b1a"};